import { render, staticRenderFns } from "./Tasa.vue?vue&type=template&id=39d39df0&scoped=true&"
import script from "./Tasa.vue?vue&type=script&lang=js&"
export * from "./Tasa.vue?vue&type=script&lang=js&"
import style0 from "./Tasa.vue?vue&type=style&index=0&id=39d39df0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d39df0",
  null
  
)

export default component.exports